import { UploadFileResponse } from "./types"

export async function uploadFiles(
  files: File[],
  carId: string,
  index: string = "0"
): Promise<UploadFileResponse> {
  const formData = new FormData()

  for (const file of files) {
    formData.append("file", file) // 'file' should match the fieldname expected by Busboy
  }

  const response = await fetch(
    `/.netlify/functions/upload-to-drive?carId=${carId}&index=${index}`,
    {
      method: "POST",
      body: formData,
      // You do not need to manually set the Content-Type when using FormData.
      // The browser will set it with the correct boundary.
    }
  )

  const result = await response.json()

  if (!response.ok) {
    throw new Error(result.error || "Upload failed")
  }

  return result as UploadFileResponse
}

export async function deleteFile(fileId: string) {
  const url = `/.netlify/functions/delete_file_from_drive?fileId=${fileId}` // Adjust with your actual Netlify function URL

  try {
    const response = await fetch(url, {
      method: "GET", // Use 'DELETE' method, since we're deleting a file/folder
    })

    if (!response.ok) {
      throw new Error(`Failed to delete: ${response.statusText}`)
    }

    const result = await response.json()
    console.log("Successfully deleted:", result)
    return result // Return the response result
  } catch (error) {
    console.error("Error deleting file/folder:", error)
    throw error // Rethrow the error for the caller to handle if needed
  }
}

export async function deleteFolder(folderId: string) {
  const url = `/.netlify/functions/delete_folder_from_drive?folderId=${folderId}` // Adjust with your actual Netlify function URL

  try {
    const response = await fetch(url, {
      method: "DELETE", // Use 'DELETE' method, since we're deleting a file/folder
    })

    if (!response.ok) {
      throw new Error(`Failed to delete: ${response.statusText}`)
    }

    const result = await response.json()
    console.log("Successfully deleted:", result)
    return result // Return the response result
  } catch (error) {
    console.error("Error deleting file/folder:", error)
    throw error // Rethrow the error for the caller to handle if needed
  }
}

export async function getFilesFromDriveFolder(folderId: string) {
  try {
    const response = await fetch(
      `/.netlify/functions/get_files_from_drive?folderId=${folderId}`
    )

    if (!response.ok) {
      const { error } = await response.json()
      throw new Error(error || "Failed to fetch files")
    }

    const data = await response.json()

    return data
  } catch (error) {
    console.error(
      "Error fetching Google Drive files:",
      (error as Error).message
    )
    throw error
  }
}
